import { TaskDependencyError } from '../features/selectors';

export const TASK_DEPENDENCY_ERRORS_TEXT: Record<TaskDependencyError, string> =
  {
    ONE_TASK_MISSING_LABWARE: 'Tasks must be assigned to different labware.',
    COMMON_LABWARE: 'Tasks must not share any common labware.',
  };
